import { Effects } from 'chessboard/plugins/effects/renderer/types';

export const timeoutWhite = `<path class="${Effects.ClassNames.Shadow}" opacity="0.3" d="M9,.5a9,9,0,1,0,9,9A9,9,0,0,0,9,.5Z"></path>
<circle class="${Effects.ClassNames.Background}" fill="#f8f8f8" cx="9" cy="9" r="8.5"></circle>
<path class="${Effects.ClassNames.ComponentShadow}" fill="#e8e8e8" d="M9,1A8,8,0,1,1,1,9,8,8,0,0,1,9,1M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z"></path>
<path d="M8.57,6.76,8.11,9.48l.89.86.89-.86L9.45,6.76ZM9,12.36A3.35,3.35,0,1,1,12.36,9,3.34,3.34,0,0,1,9,12.36Zm.7-8.29V3.62h.82V2.29h-3V3.62H8.3v.45a5,5,0,1,0,1.4,0Z"></path>`;
